export const filter = {
    number_of_data: 30,
    src: '',
    dst: '',
    call_status: '',
    disposition: '',
    calldate: '',
    phone_number: ''
};
